import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

import s from './NoResults.module.css';

const NoResults = ({ onRemoveFilters }: { onRemoveFilters: () => void }) => (
  <div className={s.noResultsWrapper}>
    <div>
      <div className={s.noResultsLabel}>
        <FormattedMessage
          defaultMessage="No exact matches."
          id="MVJTHF"
          description="Table: no matches label"
        />
      </div>
      <div className={s.noResultsHint}>
        <FormattedMessage
          defaultMessage="Try changing or <remove>remove</remove> your filters."
          id="DbRiJe"
          description="Table: try changing filters label"
          values={{
            remove: (chunks: ReactNode) => (
              <span className={s.removeFiltersAction} onClick={onRemoveFilters}>
                {chunks}
              </span>
            ),
          }}
        />
      </div>
    </div>
  </div>
);

export { NoResults };
